import React, { useLayoutEffect, useMemo, useRef } from "react";
import "./webaudio-controls/webaudio-controls-module";
export const WebAudioKnob = (props) => {
    const ref = useRef(null);
    useLayoutEffect(() => {
        const { current } = ref;
        if (current !== undefined) {
            // @ts-ignore
            current === null || current === void 0 ? void 0 : current.addEventListener("input", (event) => {
                props.onKnobInput && (props === null || props === void 0 ? void 0 : props.onKnobInput(parseFloat(event.target.value)));
                props.onKnobEvent && (props === null || props === void 0 ? void 0 : props.onKnobEvent(event));
            });
        }
    }, [ref]);
    const threeColors = useMemo(() => {
        return `${props.indicatorColor};${props.bodyColor};${props.highlightColor};`;
    }, [props.highlightColor, props.bodyColor, props.indicatorColor]);
    // @ts-ignore
    return (React.createElement("webaudio-knob", { id: (props === null || props === void 0 ? void 0 : props.id) ? props.id : "knob", ref: ref, colors: threeColors !== null && threeColors !== void 0 ? threeColors : "", ...props }));
};
